import(/* webpackMode: "eager" */ "/app/app/[lng]/application/error.tsx");
